<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'reseller.attachDomainTitle' | translate: { domain: data.resellerDomain } }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" class="attach-domain-form">
      <div class="form-field">
        <label class="field-label">{{ 'client.domain' | translate }}</label>
        <app-searchable-select
          formControlName="domain"
          [options]="availableDomains"
          [displayWith]="identityLabel"
          [valueWith]="identityLabel"
          [loading]="domainsLoading"
          [errorStateMatcher]="errorStateMatcher"
          [required]="true"
        ></app-searchable-select>
        <mat-error *ngIf="form.hasError('required', ['domain']) && errorStateMatcher.submitAttempted">
          {{ 'fieldRequired' | translate }}
        </mat-error>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCancel()" [disabled]="loading">{{ 'cancel' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="loading">
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="loading"></mat-spinner>
      <mat-icon *ngIf="!loading">link</mat-icon>
      <span *ngIf="!loading">{{ 'attach' | translate }}</span>
    </button>
  </footer>
</div>
